import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { RegistrationSource } from '@us-registration/util-models';
import {
  AbTestingService,
  ApplianceTestVariants,
} from '../../services/ab-testing/ab-testing.service';

export const abTestApplianceDetailsConversationalGuard: CanMatchFn =
  async () => {
    /* Skip the guard if the registration source is Photoreg */
    const params = new URLSearchParams(document.location.search);
    if (params.get('rs') == RegistrationSource.PR) {
      return false;
    }

    const abTestingService = inject(AbTestingService);

    return (
      (await abTestingService.getApplianceDetailsVariant()) ===
      ApplianceTestVariants.Conversational
    );
  };
